import React from 'react';

import { CheckboxSize } from '../types';
import { cn } from '../../../lib/css/className/className';
import { TestProps } from '../../../internal/types/testTypes';
import { Box as BaseBox } from '../../CheckboxBase/Box/Box';
import { getColorSkin } from '../../../lib/skin/getColorSkin/getColorSkin';
import './Box.css';

const cnBox = cn('CheckboxBox');

export interface BoxProps extends TestProps {
    size: CheckboxSize;
    isChecked?: boolean;
    isIndeterminate?: boolean;
    isDisabled?: boolean;
    isHovered?: boolean;
    isFocused?: boolean;
}

export const Box = function Box(props: BoxProps) {
    const { isChecked, isIndeterminate, isDisabled, isHovered } = props;
    const skinClass = getColorSkin(isChecked || isIndeterminate ? 'accent' : 'gray-transparent-contour', {
        isDisabled,
        isHovered,
    });

    return (
        <BaseBox
            {...props}
            className={cnBox('', [skinClass])}
            tickClassName={cnBox('tick')}
            data-testid={props['data-testid']}
        />
    );
};
